import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { format } from 'date-fns';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IHostingIndicatorsFilter } from '@pages/Hosting/filter';

export const fetch = async (
  filters: IHostingIndicatorsFilter
): Promise<{ nominal_power: number; percent_change: number }> => {
  let params = {};

  if (filters.dateFrom) {
    params = {
      ...params,
      date_from: format(new Date(filters.dateFrom), 'yyyy-MM-dd'),
    };
  }

  if (filters.dateTo) {
    params = {
      ...params,
      date_to: format(new Date(filters.dateTo), 'yyyy-MM-dd'),
    };
  }

  // const response = await api.get<IBoeingHashRate>(
  //     `${BI_BASE_URL}/boeing/hashrates`,
  //     {
  //         params: {
  //             manager_ids: filters.managers,
  //             source: filters.sources,
  //             clients: filters.sources,
  //             hosting: filters.hosting,
  //             client_categories: filters.client_categories,
  //             bulk: filters.bulk,
  //             ...params
  //         }
  //     },
  // );

  return { nominal_power: 73.0, percent_change: -9.15 };

  // return response.data ?? [];
};

export const useNominalPower = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
